module.exports = __webpack_public_path__ + "media/images/team-photo-3cd690914fb477025ddd1e7f1c574bd8.jpg";